import React from 'react';

export interface IFluxibleContext {
  executeAction: (action: Function, payload: any, done?: Function) => void;
  getStore: (storeName: string) => any;
  dispatch: (actionName: string, payload?: any) => void;
  getActionContext: () => any;
}

const FluxibleContext = React.createContext({
  executeAction: (action: Function, payload: any = {}, done?: Function) => {},
  getStore: (storeName: string) => {},
  dispatch: (actionName: string, payload?: any) => {}
});

export const FluxibleProvider = FluxibleContext.Provider;

export const useFluxibleContext = () => React.useContext(FluxibleContext) as IFluxibleContext;

export default FluxibleContext;
